import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router";

export const HeaderTitle = ({ isMobile }: { isMobile: boolean }) => {
  const { t } = useTranslation();

  return (
    <>
      <Link aria-label="british-council-logo" component={RouterLink} to="/">
        <Box sx={{ display: "flex", width: { xs: "105px", md: "140px" } }}>
          <Box
            component="img"
            src="/British_Council.svg"
            alt="British Council"
            sx={{ width: "100%", height: "100%" }}
          />
        </Box>
      </Link>

      {!isMobile && (
        <Box sx={{ display: "flex", width: "106px", height: "40px", p: "1px" }}>
          <Box
            component="img"
            src="/Cambridge.png"
            alt="Cambridge"
            sx={{ width: "100%", height: "100%" }}
          />
        </Box>
      )}

      <Typography
        noWrap
        sx={{
          fontWeight: "400",
          fontSize: "1.125rem",
          flexGrow: 1,
          color: "inherit",
        }}
      >
        {t("common.poland")}
      </Typography>
    </>
  );
};
